
// toggle/show/hide promo box PLP category card/product
function toggleMore(elem, closeAll) {
  const toggler = elem;
  const content = toggler.closest('div').next();

  if (closeAll) {
    content.hide();
    toggler.find('i').removeClass('fa-chevron-up');
  } else {
    content.toggle();
    toggler.find('i').toggleClass('fa-chevron-up');
  }
}

$('[data-collection-type]').on('click', function(){
  const wrapper = $('#collectionProductWrapper')

  if (!wrapper.hasClass('collection-list-view')) {
    location.href = $(this).data('url')
  }
})

$('[data-collection-type] .card-promo').click(function(e){
  e.stopPropagation()
});

$('.card-promo .more-toggle').on('click', function() {
  toggleMore($(this), false)
})

$('body').on('click', function() {
  toggleMore($('.card-promo .more-toggle'), true)
})

